// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_mtc","cls2":"CreateSocialItemModal-cls2_4rS CreateSocialItemModal-cls1_mtc"};